import Model from "./Model";

export default class extends Model {
    constructor(urls) {
        super(urls);
        this.urls.create_dir = urls.route_create_dir;

        this.urls.content_to_dir = urls.route_content_to_dir; // Единичное перемещение контента
        this.urls.dir_to_dir = urls.route_dir_to_dir; // Единичное перемещение директорий

        this.urls.content_to_dir_batch = urls.route_content_to_dir_batch; // Множественное перемещение контента
        this.urls.dir_to_dir_batch = urls.route_dir_to_dir_batch; // Множественное перемещение папок

        this.urls.dir_content = urls.route_dir_content;
        this.urls.dir_edit = urls.route_dir_edit;
        this.urls.dir_del = urls.route_dir_del;
        this.urls.content_upload = urls.route_content_upload;
    }

    async loadTable(page, limit, search = '', params = {}) {
        let response = await super.list(page, limit, search, params).then(result => {return result});
        let result = {
            items: [],
            pages: response.pages,
            count: response.count,
            status: response.status
        };
        if(response.items !== undefined && response.items.length > 0)
        {
            result.items = response.items;
        }
        return result;
    }

    async update(params) {
        if(this.urls.update === undefined)
        {
            console.log('error: url_update_undefined');
            return false;
        }
        return await axios.post(this.urls.update, params).then(response => {
            return response.data.status !== undefined && response.data.status === 'ok';
        })
    }

    async createDir(params) {
        if(this.urls.create_dir === undefined)
        {
            console.log('error: url_create_dir_undefined');
            return false;
        }
        return await axios.post(this.urls.create_dir, params).then(response => {
            return response.data;
        })
    }

    async contentToDir(group_id, content_id) {
        if(this.urls.content_to_dir === undefined)
        {
            console.log('error: url_content_to_dir_undefined');
            return false;
        }
        return await axios.post(this.urls.content_to_dir, {
            group_id: group_id,
            content_id: content_id
        }).then(response => {
            return response.data;
        })
    }

    async dirToDir(parent_id, child_id) {
        if(this.urls.dir_to_dir === undefined)
        {
            console.log('error: url_dir_to_dir_undefined');
            return false;
        }
        return await axios.post(this.urls.dir_to_dir, {
            parent_id: parent_id,
            child_id: child_id
        }).then(response => {
            return response.data;
        })
    }

    // Множественное перемещение контента
    async contentsToDir(group_id, content_ids = []) {
        if (this.urls.content_to_dir_batch === undefined) {
            console.log('error: url_content_to_dir_batch_undefined');
            return false;
        }
        return await axios.post(this.urls.content_to_dir_batch, {
            group_id,
            content_ids
        }).then(response => {
            return response.data;
        })
    }

    // Множественное перемещение папок
    async dirsToDir(parent_id, child_ids = []) {
        if (this.urls.dir_to_dir_batch === undefined) {
            console.log('error: url_dir_to_dir_batch_undefined');
            return false;
        }
        return await axios.post(this.urls.dir_to_dir_batch, {
            parent_id,
            child_ids
        }).then(response => {
            return response.data;
        })
    }

    async loadDir(group_id) {
        if (this.urls.dir_content === undefined) {
            console.log('error: url_dir_content_undefined');
            return false;
        }
        return await axios.post(this.urls.dir_content, {
            group_id: group_id
        }).then(response => {
            return response.data;
        })
    }

    async editGroup(group_id, name) {
        if (this.urls.dir_edit === undefined) {
            console.log('error: url_dir_edit_undefined');
            return false;
        }
        return await axios.post(this.urls.dir_edit, {
            group_id: group_id,
            name: name
        }).then(response => {
            return response.data;
        })
    }

    async deleteGroup(group_id, content) {
        if (this.urls.dir_del === undefined) {
            console.log('error: url_dir_del_undefined');
            return false;
        }
        return await axios.delete(this.urls.dir_del, {
            params: {
                group_id: group_id,
                del_content: content
            }
        }).then(response => {
            return response.data;
        })
    }

    async uploadFiles(params) {
        if (this.urls.content_upload === undefined) {
            console.log('error: url_content_upload_undefined');
            return false;
        }
        return await axios.post(this.urls.content_upload, params).then(response => {
            return response.data;
        })
    }
}
